import Vue from "vue";
import Buefy from "buefy";

import Footer from "./App.vue"


Vue.use(Buefy, {
    defaultIconPack: 'fas',
})

Vue.use(Footer)

if(document.getElementById("footer")){
    new Vue({
        render:h=>h(
            Footer,{
                props:{
                    phone:document.getElementById("footer")
                        .getAttribute("phone"),
                    email:document.getElementById("footer")
                        .getAttribute("email"),
                    direccion:document.getElementById("footer")
                        .getAttribute("direccion"),
                    localidad:document.getElementById("footer")
                        .getAttribute("localidad"),
                    companyLogo:document.getElementById("footer")
                        .getAttribute("company-logo"),
                    mpChannel: document.getElementById("footer")
                        .getAttribute("mp-channel"),
                    paypalChannel: document.getElementById("footer")
                        .getAttribute("paypal-channel"),
                    userSettingsUrl: document.getElementById("footer")
                        .getAttribute("user-settings-url"),
                    contactoUrl: document.getElementById("footer")
                        .getAttribute("contacto-url"),
                    carritoUrl: document.getElementById("footer")
                        .getAttribute("carrito-url"),
                    siteDomain: document.getElementById("footer")
                        .getAttribute("site-domain"),
                    isB2b: document.getElementById("footer")
                        .getAttribute("is-b2b"),
                    isStore: document.getElementById("footer")
                        .getAttribute("is-store"),
                    isContent: document.getElementById("footer")
                        .getAttribute("is-content"),
                }
            }
        )
    }).$mount("#footer")
}